// Thin wrapper around console that strips logging in production builds so
// error/debug details are never exposed to end users while still giving
// developers full visibility locally and in preview.
const isProd = process.env.NODE_ENV === 'production';

export const logError = (...args) => {
  if (!isProd) console.error(...args);
};

export const logDebug = (...args) => {
  if (!isProd) console.debug(...args);
};
